module.exports = __webpack_public_path__ + "img/Vision_03.6e88eac9.jpg";